<script>
import axios from 'axios'
import router from '../../router'
// cookieを有効にする
axios.defaults.withCredentials = true
const prodHostName = 'withm.net'
const prodWebApiUrl = 'https://withm.net/members/'
const devWebApiUrl = 'https://develop.withm.net/members/'

// const baseUrl = 'https://bynumbers.jp/withm/'
let baseUrl = devWebApiUrl
if (location.hostname === prodHostName) {
  // production
  baseUrl = prodWebApiUrl
}

export default {
  data () {
    return {}
  },
  check (path, param, callback, errorHandler) {
    let targetPath = baseUrl + path + param
    axios.get(targetPath).then((response) => {
      callback(response)
    }).catch(function (error) {
      console.log(error)
      router.app.$router.push('/login')
      errorHandler(error)
    })
  },
  find: function (path, param, callback, errorHandler) {
    let targetPath = baseUrl + path + param
    axios.get(targetPath).then((response) => {
      callback(response)
    }).catch(function (error) {
      errorHandler(error)
    })
  },
  search: function (path, callback, errorHandler, params) {
    let targetPath = baseUrl + path
    axios.get(targetPath).then((response) => {
      callback(response)
    }).catch(function (error) {
      errorHandler(error)
    })
  },
  update: function (path, params, callback, errorHandler) {
    let targetPath = baseUrl + path
    axios.put(targetPath, params).then((response) => {
      callback(response)
    }).catch(function (error) {
      errorHandler(error)
    })
  },
  create: function (path, params, config, callback, errorHandler) {
    let targetPath = baseUrl + path
    axios.post(targetPath, params).then((response) => {
      callback(response)
    }).catch(function (error) {
      errorHandler(error)
    })
  },
  destroy: function (path, id, callback, errorHandler) {
    let targetPath = baseUrl + path + '/' + id
    axios.delete(targetPath).then((response) => {
      callback(response)
    }).catch(function (error) {
      errorHandler(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/ApiClient.vue